"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._ExposeHeaders = {
    type: "list",
    flattened: true,
    member: {
        shape: {
            type: "string"
        }
    }
};
//# sourceMappingURL=_ExposeHeaders.js.map